// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PrescriberV3Api = class PrescriberV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Gets the Prescriber by Prescriber and Program identifiers.
     * @param prescriberId
     */
    async prescriberGetByTenantId(prescriberId) {
        const _url_ = '/prescriber/v3/Prescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling prescriberGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a list of Prescriber by Tenant identifier and list of Prescriber identifiers.
     * @param PrescriberListRequestModel PrescriberListRequestModel object containing list of Prescriber identifiers
     */
    async prescriberListByTenantId(PrescriberListRequestModel) {
        const _url_ = '/prescriber/v3/PrescriberList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PrescriberListRequestModel' is not null or undefined
        if (PrescriberListRequestModel === null || PrescriberListRequestModel === undefined) {
            throw new Error('Required parameter PrescriberListRequestModel was null or undefined when calling prescriberListByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PrescriberListRequestModel, "PrescriberListRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModels");
        }
        return response;
    }
    /**
     *
     * @summary Searches for Prescribers matching criteria.
     * @param PrescriberSearchRequestModel PrescriberSearchRequestModel object
     */
    async prescriberSearchByTenantId(PrescriberSearchRequestModel) {
        const _url_ = '/prescriber/v3/PrescriberSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PrescriberSearchRequestModel' is not null or undefined
        if (PrescriberSearchRequestModel === null || PrescriberSearchRequestModel === undefined) {
            throw new Error('Required parameter PrescriberSearchRequestModel was null or undefined when calling prescriberSearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PrescriberSearchRequestModel, "PrescriberSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Upsearch Prescriber
     * @param UpsearchModelPrescriberPrescriberUpsearchModel PrescriberUpsearchModel object
     */
    async prescriberUpsearchByTenantId(UpsearchModelPrescriberPrescriberUpsearchModel) {
        const _url_ = '/prescriber/v3/PrescriberUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'UpsearchModelPrescriberPrescriberUpsearchModel' is not null or undefined
        if (UpsearchModelPrescriberPrescriberUpsearchModel === null || UpsearchModelPrescriberPrescriberUpsearchModel === undefined) {
            throw new Error('Required parameter UpsearchModelPrescriberPrescriberUpsearchModel was null or undefined when calling prescriberUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(UpsearchModelPrescriberPrescriberUpsearchModel, "UpsearchModelPrescriberPrescriberUpsearchModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get a list of Prescribers by Tenant and Site identifiers
     * @param siteId Site identifier
     */
    async prescribersBySiteGetByTenantId(siteId) {
        const _url_ = '/prescriber/v3/PrescribersBySite/{siteId}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling prescribersBySiteGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PrescriberModels");
        }
        return response;
    }
};
PrescriberV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PrescriberV3Api);
export { PrescriberV3Api };
//# sourceMappingURL=prescriberV3Api.js.map